import axios from 'axios'


class CommonApiCall{
    get = axios.get;
    post = axios.post;

}

const commonApiCall = new CommonApiCall();

export default commonApiCall;